export default __webpack_public_path__ + "static/media/portfolio-75.83f32839.jpg";